import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RangeSlider',
  props: {
    value: null,
    disabled: { type: Boolean, default: false },
    step: { default: 1 },
    min: { default: 0 },
    max: { default: 10 },
    thumbLabel: { type: [Boolean, String] },
    translations: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number[], disabled: boolean, step: number, min: number, max: number, thumbLabel?: boolean | string, translations: {
      from : string,
      to: string,
      name: string
    } };



const range = computed({
  get: () => props.value,
  set: (newValue) => emit('input', newValue)
});




return { __sfc: true,props, range, emit }
}

})